module.exports = __webpack_public_path__ + "static/img/robot.41fc8e68.webp";